import React, { useState } from 'react';
import { styled } from '@mui/system';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const AccodianRoot = styled('div')({
  width: '100%',
});

const AccodianChecklist = (props) => {
  // const classes = useStyles();
  const [] = useState(props.accordianNo);
  const [] = useState(null);

  const handleChange = (index) => () => {
    localStorage.setItem('expandedNo', index);
  };
  const [user] = useState(props.currentUser);

  return (
    <AccodianRoot>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1a-content'
          id='panel1a-header'
        >
          {props.category}
        </AccordionSummary>
        {props.subCategory.map((item, index) => (
          <Accordion
            onChange={handleChange(index)}
            //defaultExpanded={index === expanded ? true : ''}
            sx={{ backgroundColor: '#d2e4f5', marginLeft: '34px' }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls=''
              id=''
            >
              {item.subCategory}
            </AccordionSummary>
            {item.name.map((item1) => (
              <AccordionDetails sx={{ backgroundColor: item1.createdBy!='Admin'?'#3c8dbc':'white' }}>
                <td className='col-md-12 text-left'>
                  {/* {item1.name} */}

                  {item1.name}{item1.checkListStyle}
                </td>
                {props.checkName === 'Monthly SOD' ||
                props.checkName === 'Diagnosis - Store Handovers' ||
                props.checkName === 'Diagnosis SOD' ? (
                  <td className='col-md-8 text-right'>{item1.questionType}</td>
                ) : (
                  ''
                )}
                <td className='col-md-12'>
                  <div className='todo-icon'>
                    <span
                      className='mx-8 text-success text-right'
                      style={{
                        cursor: 'pointer',
                        marginLeft:
                          props.checkName === 'Monthly SOD' ||
                          props.checkName === 'Diagnosis - Store Handovers' ||
                          props.checkName === 'Diagnosis SOD'
                            ? '160px'
                            : '225px',
                      }}
                      onClick={() => {
                        props.editRow({
                          id: item1.id,
                          name: item1.name,
                          category: props.category,
                          subCategory: item.subCategory,
                          newCategory: props.category,
                          newSubCategory: item.subCategory,
                          questionType: item1.questionType,
                        });
                      }}
                    >
                      <i className='fas fa-pen'></i>
                    </span>
                    <span
                      className='mx-8 text-danger text-right'
                      style={{ cursor: 'pointer', marginLeft: '50px' }}
                      onClick={() => props.deleteUser(item1.id)}
                    >
                      <i className='fas fa-trash'></i>
                    </span>
                  </div>
                </td>
              </AccordionDetails>
            ))}
          </Accordion>
        ))}
      </Accordion>
    </AccodianRoot>
  );
};
export default AccodianChecklist;
